import React, { useEffect, useRef } from 'react';
import './SearchSelect.css';

interface SearchSelectProps {
  items: string[];
  onSelect: (item: string) => void;
  placeholder?: string;
  value?: string;
}

function SearchSelect({
  items,
  onSelect,
  placeholder,
  value,
}: SearchSelectProps): JSX.Element {
  const [query, setQuery] = React.useState(value || '');
  const [showDropdown, setShowDropdown] = React.useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const filteredItems = items.filter((item) =>
    item.toLowerCase().includes(query.toLowerCase())
  );

  const handleSelect = (item: string) => {
    onSelect(item);
    setQuery(item);
    setShowDropdown(false);
  };

  // Sync query with external value changes
  useEffect(() => {
    setQuery(value || '');
  }, [value]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="SearchSelectContainer" ref={containerRef}>
      <input
        type="text"
        value={query}
        placeholder={placeholder || 'Search...'}
        onChange={(e) => {
          setQuery(e.target.value);
          setShowDropdown(true);
        }}
        onFocus={() => setShowDropdown(true)}
        className="SearchSelectInput"
      />
      {showDropdown && filteredItems.length > 0 && (
        <ul className="SearchSelectDropdown">
          {filteredItems.map((item, idx) => (
            <li
              key={idx}
              onClick={() => handleSelect(item)}
              className="SearchSelectItem"
            >
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default SearchSelect;
